"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BAND_TITLE_COLOR = exports.SHADOW_KIND = exports.BG_COLOR = exports.BORDER_COLOR = exports.BORDER_KIND = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

require("./Card.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const BORDER_KIND = {
  LINE: 'line',
  ROUNDED: 'rounded',
  FULL_ROUNDED: 'fullRounded',
  NONE: 'none'
};
exports.BORDER_KIND = BORDER_KIND;
const BORDER_COLOR = {
  WHITE: 'white',
  TRANSPARENT: 'transparent',
  BLACK: 'black',
  GREY_3: 'grey3'
};
exports.BORDER_COLOR = BORDER_COLOR;
const BG_COLOR = {
  WHITE: 'white',
  TRANSPARENT: 'transparent',
  BLACK: 'black'
};
exports.BG_COLOR = BG_COLOR;
const SHADOW_KIND = {
  SHADOW1: 'shadow1',
  NONE: 'none'
};
exports.SHADOW_KIND = SHADOW_KIND;
const BAND_TITLE_COLOR = {
  NO: 'no',
  EGG: 'egg',
  ORANGE: 'orange',
  PURPLE: 'purple',
  BLUE: 'blue',
  GREEN: 'green'
};
exports.BAND_TITLE_COLOR = BAND_TITLE_COLOR;

class Card extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "getBorderCss", border => {
      return ` Card_borderKind--border-${border}`;
    });

    _defineProperty(this, "getBorderColorCss", borderColor => {
      return ` Card_borderColor--${borderColor}`;
    });

    _defineProperty(this, "getCssShadow", shadow => {
      return ` Card_shadow--${shadow}`;
    });

    _defineProperty(this, "handleClick", () => {
      const {
        selected
      } = this.state;
      const {
        onClick
      } = this.props;

      if (onClick) {
        onClick();
      }

      this.setState({
        selected: !selected
      });
    });

    const {
      selected: _selected
    } = props;
    this.state = {
      selected: _selected
    };
  }

  render() {
    const {
      selected
    } = this.state;
    const {
      className,
      bandTitleColor,
      children,
      border,
      bgColor,
      borderColor,
      shadow,
      onClick,
      taggingInfo,
      isClickable
    } = this.props;

    if (!children) {
      return null;
    }

    const selectedCss = selected ? ' selected' : '';
    const bandTitleExist = bandTitleColor && bandTitleColor !== BAND_TITLE_COLOR.NO;
    const isTherBandColor = bandTitleExist ? ' CardWidthbandTitleColor' : '';
    const cssCardBackgroundColor = bgColor ? ` Card_bgColor--${bgColor}` : '';
    const cssBorderColor = this.getBorderColorCss(borderColor);
    const cssShadow = this.getCssShadow(shadow);
    const cssClick = !onClick ? 'defaultCursor' : '';
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `Card${isTherBandColor}${selectedCss}${cssCardBackgroundColor}${cssBorderColor}${this.getBorderCss(border)}${cssShadow} ${cssClick} ${className}`,
      children: [bandTitleExist && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `bandTitleColor bandTitleColor_color--${bandTitleColor}`
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "cardContent",
        children: children && children
      }), isClickable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        taggingInfo: taggingInfo,
        isBlockElement: true,
        onClick: this.handleClick,
        className: "cardLink"
      })]
    });
  }

}

Card.propTypes = {
  /**
   * {
   *  "info": "Define el className del componente",
   *  "kind": "playground",
   *  "beautifulName": "ClassName"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Define el children del componente",
   *  "kind": "playground",
   *  "beautifulName": "Children"
   * }
   */
  children: _propTypes.default.node,

  /**
   * {
   *  "info": "Color del título del componente",
   *  "kind": "both",
   *  "beautifulName": "Color título"
   * }
   */
  bandTitleColor: _propTypes.default.oneOf([BAND_TITLE_COLOR.NO, BAND_TITLE_COLOR.EGG, BAND_TITLE_COLOR.ORANGE, BAND_TITLE_COLOR.PURPLE, BAND_TITLE_COLOR.BLUE, BAND_TITLE_COLOR.GREEN]),

  /**
   * {
   *  "info": "Color del fondo del componente",
   *  "kind": "both",
   *  "beautifulName": "Color fondo"
   * }
   */
  bgColor: _propTypes.default.oneOf([BG_COLOR.WHITE, BG_COLOR.TRANSPARENT, BG_COLOR.BLACK]),

  /**
   * {
   *  "info": "Define el tipo de border del componente",
   *  "kind": "both",
   *  "beautifulName": "Tipo border"
   * }
   */
  border: _propTypes.default.oneOf([BORDER_KIND.LINE, BORDER_KIND.NONE, BORDER_KIND.ROUNDED, BORDER_KIND.FULL_ROUNDED]),

  /**
   * {
   *  "info": "Define el color del border del componente",
   *  "kind": "both",
   *  "beautifulName": "Color border"
   * }
   */
  borderColor: _propTypes.default.oneOf([BORDER_COLOR.WHITE, BORDER_COLOR.BLACK, BORDER_COLOR.TRANSPARENT, BORDER_COLOR.GREY_3]),

  /**
   * {
   *  "info": "Define el tipo de sombra del componente",
   *  "kind": "both",
   *  "beautifulName": "Tipo sombra"
   * }
   */
  shadow: _propTypes.default.oneOf([SHADOW_KIND.NONE, SHADOW_KIND.SHADOW1]),

  /**
   * {
   *  "info": "Define si el componente esta seleccionado o no",
   *  "kind": "both",
   *  "beautifulName": "Seleccionado"
   * }
   */
  selected: _propTypes.default.bool,

  /**
   * {
   *  "info": "Define si el componente se puede clickar",
   *  "kind": "both",
   *  "beautifulName": "Seleccionado"
   * }
   */
  isClickable: _propTypes.default.bool
};
Card.defaultProps = {
  className: '',
  children: null,
  bgColor: BG_COLOR.WHITE,
  bandTitleColor: BAND_TITLE_COLOR.NO,
  selected: false,
  border: BORDER_KIND.NONE,
  borderColor: BORDER_COLOR.BLACK,
  shadow: SHADOW_KIND.SHADOW1,
  isClickable: true
};
var _default = Card;
exports.default = _default;

//# sourceMappingURL=index.js.map